// extracted by mini-css-extract-plugin
export var brand = "_34-9";
export var button = "_34-0";
export var chevron = "_34-v";
export var chevronButton = "_34-w";
export var content = "_34-n";
export var danger = "_34-g";
export var dangerOutlined = "_34-h";
export var dark = "_34-l";
export var darkTheme = "_34-c";
export var extraSmall = "_34-4";
export var fullWidth = "_34-8";
export var ghost = "_34-d";
export var gray = "_34-t";
export var icon = "_34-p";
export var iconButton = "_34-s";
export var iconButtonBorder = "_34-x";
export var iconButtonBorderDark = "_34-y";
export var iconButtonBorderLight = "_34-z";
export var iconLeft = "_34-q";
export var iconRight = "_34-r";
export var large = "_34-1";
export var light = "_34-m";
export var medium = "_34-2";
export var micro = "_34-5";
export var nano = "_34-7";
export var outlined = "_34-k";
export var pending = "_34-a";
export var primary = "_34-i";
export var shadow = "_34-o";
export var small = "_34-3";
export var solidLight = "_34-e";
export var solidLightBrand = "_34-f";
export var spinner = "_34-u";
export var transparent = "_34-j";
export var warning = "_34-b";
export var wideNano = "_34-6";